import { PagedSearch } from '../../shared/model/index';

export class ClickLogSearch extends PagedSearch {
  public MessageId: number = 0;
  public Url: string = '';
}
